import PageContainer from './PageContainer';
import session from '../models/Session';
import _ from 'lodash';
import Draft from '../models/Draft';
import DraftSessions from '../models/DraftSessions';
import Template from '../models/Template';
import User from '../models/User';
import Store from '../models/Store';
import socket from '../libraries/socket'; 

export default class CrewDraftContainer extends PageContainer {
  state = {
    participants: [],
    textbox: '',
    template: null,
    draft: null,
    draftSessions: {},
  }
 
  options = {
    defaultState: {
      draft: Draft.mock(),
      template: Template.mock(),
      draftSessions: DraftSessions.mockState(),
      participants: _.range(30).map(i => User.mock())
    },
    getFromSession: ['template', 'draft', 'draftSessions'],
    flags: [{
      name: 'isLoaded',
      check: () => true,
    }],
  }

  async setup(options) {
    await this.subscribeToSession();

    if (!(this.state.draft && this.state.template && this.state.draftSessions.next)) {
      await session.fetchLocal();
      console.log("I am on 1st loop")
    }

    if (!(this.state.draftSessions.next && this.state.draftSessions.completed.length)) {

      console.log("I am on 2nd loop")

      if (!this.state.draft) {
        session.set('draft', new Draft());
        await this.setState({
          draft: session.get('draft')
        });
        console.log("I am on 2.1 loop")
      }
      if (this.state.draft.createdAt && !options.forceNew) {
        session.startJam(this.state.draft);
        console.log("I am on 2.2 loop")
        console.log(this.state.draft.createdAt)
      } else if (session.get('draft').title && session.get('draft').blurb) {

        if (options.forceNew) {
          session.set('draft', session.get('draft').clone());
          await this.setState({
            draft: session.get('draft')
          });
        }

        session.get('draft').set('createdBy', session.getUser()._id);
        session.get('draft').set('createdAt', new Date());
        const newDraft = await this.state.draft.syncCreate();
        session.set('draft', session.get('draft').set(newDraft));
        session.set('template', newDraft.template);
        session.startJam(this.state.draft);
        console.log(" I am on 2.2 else loop")
      }
    } else if (this.state.draftSessions.next) {
      session.startDraftSession(this.state.draftSessions.next || _.head(this.state.template.sessions));
      console.log("I am on 2nd else loop")
    }

      // session.selectTemplate(this.state.template);
      // await this.setState(state => _.assign(state, this.options.defaultState));
    // }

    // this.state.draft.changes$.subscribe((next) => console.log('Draft changed', next, session.store) );
    // this.state.draft.store$.subscribe((next) => console.log('Draft changed, store now is', next, session.store) );

    // session.changes$.subscribe((next) => console.log('Session changed', next) );
    // session.store$.subscribe((next) => console.log('Session changed, store now is', next) );

    console.log('CrewDraftContainer:setup complete', this.state);
    socket.syncWithParticipants();
  }

  destroy() {
    this.unsubscribeAll();
  }

  handleChange = (object) => (e) => {
  }

  onAddParticipant = (participant) => {
    console.log('onAddParticipant', participant); 

    this.state.draft.addParticipant(participant);
  }

  onRemoveParticipant = (participant) => {

    console.log('onRemoveParticipant', participant); 

    this.state.draft.removeParticipant(participant);
  }

  constructor(props) {
    super(props);
    this.getPropsFromSession(this.options.getFromSession);
    this.setupFlags(this.options.flags);
  }
}



// WEBPACK FOOTER //
// ./src/containers/CrewDraftContainer.js